(ns teamoesterreich.admin-mode.event.detail.member-selector.filter-router
  (:require
    [clojure.string]
    [reagent.core :as r]
    [teamoesterreich.admin-mode.data.rights :as d-rights]
    [teamoesterreich.admin-mode.event.detail.member-selector.filter-boolean :as f-boolean]
    [teamoesterreich.admin-mode.event.detail.member-selector.filter-age :as f-age]
    [teamoesterreich.admin-mode.event.detail.member-selector.filter-organization :as f-organization]
    [teamoesterreich.admin-mode.event.detail.member-selector.filter-base-org :as f-base-org]
    ))


(def FILTER_OPTIONS
  [
   {:key :base-org :hide true :name "Basis Verband / Organisation" :type :base-org :initial (fn [] (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))) :short (fn [v] v)}
   {:key :organization :name "Verband / Organisation" :type :organization :initial (fn [] (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))) :short (fn [v] v)}
   ;{:key :language :name "Sprache" :type :multi-select :initial [:de] :options {:de "deutsch" :en "english"} :short (fn [v] v)}
   {:key :helpingLebensretter :name "Will Lebensretter " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}

   ;:key  :helpingManualWork           :name "manuelle Tätigkeiten" :type :numeric :initial true}
   ;:key :helpingProfessionalSkills           :name "professionelle Tätigkeiten" :type :numeric :initial true}

   {:key :age :name "Alter" :type :numeric :initial 18 :short (fn [v] v)}
   {:key :isLebensretter :name "Ist Lebensretter " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}

   {:key :isRk :name "Ist Rotes Kreuz Mitglied " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}

   {:key :helpingCat :name "Will helfen bei Katastrophe " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingKatAdministrativ :name "Bei Katastrophe: Unterstützung bei administrativen Tätigkeiten. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingKatBBetreuung :name "Bei Katastrophe: Unterstützung bei der Betreuung von Menschen mit besonderen Bedürfnissen. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingKatSicherungsarbeiten :name "Bei Katastrophe: Unterstützung bei Sicherungsarbeiten. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingKatHilfsaktivitaeten :name "Bei Katastrophe: Unterstützung bei anderen Hilfsaktivitäten. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingKatInformationstgk :name "Bei Katastrophe: Unterstützung bei Informationstätigkeiten. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingKatLogistik :name "Bei Katastrophe: Unterstützung bei Logistik-Aufgaben. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingKatAufraeumungsarbeiten :name "Bei Katastrophe: Mithilfe bei Aufräumungsarbeiten. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}


   {:key :helpingNoCat :name "Will helfen ohne Katastrophe " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNormEinmalAufgaben :name "Ohne Katastrophe: für \"Einmal-Aufgaben\". " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNormProjekt :name "Ohne Katastrophe: Unterstützung bei Projekten. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNormLogistik :name "Ohne Katastrophe: Unterstützung in der Logistik. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNormVeranstaltungen :name "Ohne Katastrophe: Unterstützung bei Rotkreuz-Veranstaltungen. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNormAdministrativen :name "Ohne Katastrophe: Administrativen Unterstützung. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNormCampaigning :name "Ohne Katastrophe: Durchführung von Marketing-Aufgaben. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNormHilfsaktivitaeten :name "Ohne Katastrophe: Unterstützung bei anderen Hilfsaktivitäten. " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}

   {:key :helpingCrowdTasker :name "Crowdtasker " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingNeighbor :name "Nachbarschaftshilfe " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}

   {:key :helpingTafel :name "Tafel " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingTafelOnce :name "Tafel: Gelegentlich mitzuarbeiten " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingTafelRegular :name "Tafel: Regelmäßig mitzuarbeiten " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingTafelDriver :name "Tafel: Fahrer bei der Lebensmittelabholung zu unterstützen " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingTafelHelper :name "Tafel: Helfer bei der Lebensmittelabholung " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}
   {:key :helpingTafelDeliverer :name "Tafel: Lebensmittelzusteller mitzuarbeiten " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}

   {:key :userTester :name "Ist Tester " :typeInfo "[Ja/Nein]" :type :bool :initial true :short (fn [v] (if v "JA" "NEIN"))}

   ])

(def FILTER_OPTIONS_MAP (reduce (fn [c e] (assoc c (:key e) e)) {} FILTER_OPTIONS))

(defn get-defaults [_type]
  (let [options (get FILTER_OPTIONS_MAP _type)]
    {:type _type :name (:name options)
     :short ((:short options) (if (fn? (:initial options)) ((:initial options)) (:initial options)))
     :val (if (fn? (:initial options)) ((:initial options)) (:initial options))}
    )
  )



(defn edit-filter-popup [!show-popup !filter-block]
  (fn []
    (when @!show-popup
      (let [!filter-item (r/cursor !filter-block [@!show-popup])
            opt (get FILTER_OPTIONS_MAP (keyword (:type @!filter-item)))]
        (try
          (println "edit-filter-popup" @!filter-item opt)
          (case (:type opt)
            :age (f-age/edit-filter-popup opt !show-popup !filter-item)

            :bool (f-boolean/edit-filter-popup opt !show-popup !filter-item)

            :organization (f-organization/edit-filter-popup opt !show-popup !filter-item)

            :base-org (f-base-org/edit-filter-popup opt !show-popup !filter-item)

            )
          (catch js/Error e (println "Filter-Popup not found for:" @!filter-item " E " e)))))))


